export enum EServerStatus {
    IS_ACTIVE = 'active',
    IS_UNACTIVE = 'unactive',
    IS_LOADING = 'loading'
}
